import { A3MM, A4MM, BasePDFNode, getYoga, RectPDFNode, TextPDFNode } from "./BasePDFNode";
import jsPDF from "jspdf";
import { RangedKanaalAssign } from "../props/PropTypes";
import { Kaart, Rack } from "../kanaal/hdw-config/HdwSysteem";
import { FastlinkXTPDFNode, KaartPDFNode, measureKlem } from "./KaartPDFNode";
import { PageCardNode } from "./PageCardNode";
import { RackXTPDFNode } from "./RackXTKaart";

type KaartPlace = {
    kaart?: Kaart,
    reversed: boolean,
    rack: Rack
}

export class RackPDFNode extends BasePDFNode {

    constructor(public pdf: jsPDF, public kanaalMap: Record<string, Array<Array<RangedKanaalAssign>>>, public rack: Rack, public lastVeldStation: boolean = false
    ) {

        super(pdf, {
            flexDirection: 'column',
            flexGrow: 1,
            margin: 2,
            padding: 2,

        }, getYoga().Node.create());
    }

    public pageCard: PageCardNode | undefined;

    private measureKartRows(page: KaartPlace) {
        if (page.kaart == undefined) {
            return 0;
        }
        let hwdLayout = page.kaart.getHdwLayout();
        return measureKlem(hwdLayout, this.kanaalMap);
    }


    private getPlaces(): KaartPlace[] {
        let ret: KaartPlace[] = [];
        let rackKarten = this.rack.kaarten.filter(k => k.type.takesRackSpace);
        console.log(this.rack.type.label);
        if ((this.rack.type.bus == "fastlink") && (this.rack.type.label == "Veldstation")) {
            ret.push({
                kaart: rackKarten[0],
                reversed: false,
                rack: this.rack
            });
            console.log("adding ", 0);
            ret.push({
                reversed: false,
                rack: this.rack
            });
            for (let i = 0; i < Math.min(rackKarten.length - 1, 3); i++) {
                console.log("adding ", i+1);
                ret.push({
                    kaart: rackKarten[i + 1],
                    reversed: false,
                    rack: this.rack
                });
                let reverseIndex = 6 - i;
                if (reverseIndex < rackKarten.length) {
                    ret.push({
                        kaart: rackKarten[reverseIndex],
                        reversed: true,
                        rack: this.rack
                    });
                    console.log(`Adding: ${reverseIndex}`);
                } else {
                    ret.push({
                        reversed: false,
                        rack: this.rack
                    });
                    console.log(`${reverseIndex} >= ${rackKarten.length} adding hole`);

                }

            }
        } else {
            return rackKarten.map(kaart => {
                return {
                    kaart: kaart,
                    reversed: false,
                    rack: this.rack
                }
            })
        }
        return ret;
    }
    public init(): void {
        let label = "";
        if (this.rack.type.hideNumber) {
            label = `${this.rack.type.label}`;
        } else {
            label = `${this.rack.type.label} ${this.rack.number}`;
        }
        let kartPages: KaartPlace[][] = [];
        let page: KaartPlace[] = [];
        let maxRowsPerPage = 88;
        let currentRows = 0;
        let row: KaartPlace[] = [];
        for (let kaart of this.getPlaces()) {
            row.push(kaart);
            if (row.length == 2) {
                let firstColSize = this.measureKartRows(row[0]);
                let secondColSize = this.measureKartRows(row[1]);
                let maxSize = Math.max(firstColSize, secondColSize);
                console.log(`Row sizes: (${firstColSize} , ${secondColSize})`)
                if (currentRows + maxSize > maxRowsPerPage) {
                    kartPages.push(page);
                    page = [];
                    currentRows = 0;
                }
                currentRows = currentRows + maxSize;
                page.push(row[0]);
                page.push(row[1]);
                row = [];
            }
        }
        if (row.length > 0) {
            let firstColSize = this.measureKartRows(row[0]);
            let maxSize = Math.max(firstColSize, 0);
            console.log(`Last row: (${firstColSize} )`)
            if (currentRows + maxSize > maxRowsPerPage) {
                kartPages.push(page);
                page = [];
                currentRows = 0;
            }
            currentRows = currentRows + maxSize;
            page.push(row[0]);
            row = [];
        }

        if (page.length > 0) {
            kartPages.push(page);
        }
        for (let i = 0; i < kartPages.length; i++) {
            let karten = kartPages[i];
            let pageLabel = label;
            if (i > 0) {
                pageLabel = `${label} - Page ${i + 1}`;
            }

            this.addChild2(new RackPage(this.pdf, this.kanaalMap, karten, pageLabel, this.lastVeldStation)).pageCard = this.pageCard;
        }
        super.init();
    }

}

class RackPage extends BasePDFNode {
    constructor(public pdf: jsPDF, public kanaalMap: Record<string, Array<Array<RangedKanaalAssign>>>, public kaarten: KaartPlace[], 
        public label: string, public lastVeldStation: boolean = false
    ) {

        super(pdf, {
            flexDirection: 'column',
            flexGrow: 1,
            margin: 2,
            padding: 2,

        }, getYoga().Node.create());
    }

    public pageCard: PageCardNode | undefined;

    public init(): void {
        let txt = this.addChild2(new TextPDFNode(this.pdf, {
            fontSize: 12,
            marginBottom: 2
        }));
        txt.text = this.label;
        let kartContainer = this.addChild2(new BasePDFNode(this.pdf, {
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: "space-between",
            rowGap: 2,
            flexGrow: 1,

        }));
        for (let kaart of this.kaarten) {
            if (kaart.kaart != undefined) {
                if (kaart.kaart.type.metaId =='fastlink_xt') {
                    kartContainer.addChild2(new FastlinkXTPDFNode(this.pdf, this.kanaalMap, kaart.kaart, true, 0, false));    
                } else if (kaart.kaart.type.metaId == 'mainRackXtender') {
                    kartContainer.addChild2(new FastlinkXTPDFNode(this.pdf, this.kanaalMap, kaart.kaart, false, kaart.rack.kaarten.length - 1, true, this.lastVeldStation));    
                } else if (kaart.kaart.type.metaId == 'scx_xt') {
                    kartContainer.addChild2(new RackXTPDFNode(this.pdf, this.kanaalMap, kaart.kaart, kaart.reversed));
                } else {
                    kartContainer.addChild2(new KaartPDFNode(this.pdf, this.kanaalMap, kaart.kaart, kaart.reversed));
                }
                
            } else {
                kartContainer.addChild2(new TextPDFNode(this.pdf, {
                    width: 140,
                    maxWidth: 140,
        
                }));
            }
            // break;
        }
        super.init();
    }

    public render(): void {
        this.pdf.addPage("a3", "p");
        // this.layout.calculateLayout(A3MM.height, A3MM.width);
        this.layout.calculateLayout(A3MM.width, A3MM.height);

        if (this.pageCard == undefined) {
            let l = this.layout.getComputedLayout();
            let topLeft = this.getTopLeft();
            this.pdf.rect(topLeft.x, topLeft.y, l.width, l.height);
        } else {
            this.pageCard.render();
        }

        super.render();
    }
}